<!-- <app-spinner [show]="isLoading.stateList || isLoading.billingAddress || isLoading.saveBillingAddress || isLoading.saveShippingAddress ||
isLoading.shippingAddress" [size]="150"> </app-spinner> -->
<form [formGroup]="form">
  <div class="container" style="margin-bottom: 100px;">
    <div class="row">
      <div class="cols-m-12 col-md-12 col-lg-12">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12 address-section-title">
            Billing Address
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-6">
            <mat-form-field class="clsGapping">
              <mat-label>Name</mat-label>
              <input matInput formControlName="BillingName" placeholder="Billing Name" required>
              <mat-error *ngIf="getBillingName.errors?.required">Billing Name is required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6">
            <mat-form-field class="clsGapping">
              <mat-label>Street Address</mat-label>
              <input matInput formControlName="BillingStreetAddress" placeholder="Street  Address" required>
              <mat-error *ngIf="getBillingStreetAddress.errors?.required">Street address is required</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-6">
            <mat-form-field class="clsGapping">
              <mat-label>City</mat-label>
              <input matInput formControlName="BillingCity" placeholder="City" required>
              <mat-error *ngIf="getBillingCity.errors?.required">City is required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6">
            <mat-form-field class="clsGapping">
              <mat-label>State</mat-label>
              <mat-select formControlName="BillingState" placeholder="State" required style="font-family: Arial, Helvetica, sans-serif;">
                <mat-option>None</mat-option>
                <mat-option *ngFor="let state of statelist" [value]="state">{{state.name}}</mat-option>
              </mat-select>
              <mat-error *ngIf="getBillingState.errors?.required">State is required</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-6">
            <mat-form-field class="clsGapping">
              <mat-label>Zip Code</mat-label>
              <input matInput formControlName="BillingZipCode" placeholder="Zip Code" required maxlength="5" numbersonlyChecker>
              <mat-error *ngIf="form.controls['BillingZipCode'].hasError('required')">Zip Code is required</mat-error>
              <mat-error *ngIf="form.controls['BillingZipCode'].hasError('minlength')">Zip Code min length is 5.</mat-error>
              <mat-error *ngIf="form.controls['BillingZipCode'].hasError('maxlength')">Zip Code max length is 10.</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button type="button" class="account-cta" (click)="validateBillingAddress()"
                    [disabled]="isValidatingBillingAddress || !getBillingStreetAddress.value || !getBillingCity.value || !getBillingState.value || !getBillingZipCode.value">
              <span *ngIf="!isValidatingBillingAddress">Validate Billing Address</span>
              <span *ngIf="isValidatingBillingAddress">Validating...</span>
            </button>
            <div *ngIf="billingAddressValidation && billingAddressValidation.success && billingAddressValidation.isValid"
                 class="address-valid">
              ✓ Address validated successfully
            </div>
            <div *ngIf="billingAddressValidation && billingAddressValidation.dpvDescription"
                 class="address-note">
              {{ billingAddressValidation.dpvDescription }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12 address-section-title">
            Shipping Address
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <mat-checkbox class="clsGapping" formControlName="ShipingAsBilling" style="font-family: Verdana, Geneva, Tahoma, sans-serif;">Shipping same as billing
            </mat-checkbox>
          </div>
        </div>
        <div >
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <mat-form-field class="clsGapping">
                <mat-label>Street Address</mat-label>
                <input matInput formControlName="ShipingStreetAddress" placeholder="Street  Address" required>
                 <mat-error *ngIf="getShipingStreetAddress.errors?.required">Street address is required</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
              <mat-form-field class="clsGapping">
                <mat-label>City</mat-label>
                <input matInput formControlName="ShipingCity" placeholder="City" required>
                <mat-error *ngIf="getShipingCity.errors?.required">City is required</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <mat-form-field class="clsGapping">
                <mat-label>State</mat-label>
                <mat-select formControlName="ShipingState" placeholder="State" required style="font-family: Arial, Helvetica, sans-serif;">
                  <mat-option>None</mat-option>
                  <mat-option *ngFor="let state of statelist" [value]="state">{{state.name}}</mat-option>
                </mat-select>
                <mat-error *ngIf="getShipingState.errors?.required">State is required</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
              <mat-form-field class="clsGapping">
                <mat-label>Zip Code</mat-label>
                <input matInput formControlName="ShipingZipCode" placeholder="Zip Code" required maxlength="5" numbersonlyChecker>
                <mat-error *ngIf="form.controls['ShipingZipCode'].hasError('required')">Zip Code is required</mat-error>
                <mat-error *ngIf="form.controls['ShipingZipCode'].hasError('minlength')">Zip Code min length is 5.</mat-error>
                <mat-error *ngIf="form.controls['ShipingZipCode'].hasError('maxlength')">Zip Code max length is 10.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <button type="button" class="account-cta" (click)="validateShippingAddress()"
                      [disabled]="isValidatingShippingAddress || getShipingAsBilling.value || !getShipingStreetAddress.value || !getShipingCity.value || !getShipingState.value || !getShipingZipCode.value">
                <span *ngIf="!isValidatingShippingAddress">Validate Shipping Address</span>
                <span *ngIf="isValidatingShippingAddress">Validating...</span>
              </button>
              <div *ngIf="shippingAddressValidation && shippingAddressValidation.success && shippingAddressValidation.isValid"
                   class="address-valid">
                ✓ Address validated successfully
              </div>
              <div *ngIf="shippingAddressValidation && shippingAddressValidation.dpvDescription"
                   class="address-note">
                {{ shippingAddressValidation.dpvDescription }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-6">
            <button type="button" class="account-cta" (click)="SaveAddress()">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
